import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";
import { useCart } from "@/context/CartContext";
import { scrollToId } from "@/components/SmoothScroll";

const LINKS = [
  { id: "flavors", label: "Flavors" },
  { id: "contact", label: "Contact" },
];

export const Header = () => {
  const { count, setOpen } = useCart();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const go = (id) => {
    if (pathname === "/") scrollToId(id);
    else navigate(`/#${id}`);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#E5A910]/80 backdrop-blur-xl border-b border-black/10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-brand-logo" aria-label="SweetJuice home">
          <Logo />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-${l.id}-link`} onClick={() => go(l.id)} className="relative group">
              {l.label}
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-[#181203] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
          <Link to="/shop" data-testid="nav-shop-link" className="relative group">
            Shop
            <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-[#181203] transition-[width] duration-300 group-hover:w-full" />
          </Link>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/shop" data-testid="nav-shop-link-mobile" className="md:hidden text-sm font-bold underline underline-offset-4">
            Shop
          </Link>
          <motion.button
            whileTap={{ scale: 0.92 }}
            data-testid="cart-trigger-button"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 rounded-full bg-[#181203] text-[#FFD000] pl-4 pr-5 h-11 text-sm font-bold hover:bg-black transition-colors"
          >
            <ShoppingBag className="w-4 h-4" />
            Cart
            <span data-testid="cart-item-count" className="ml-1 grid place-items-center min-w-6 h-6 px-1.5 rounded-full bg-[#FFD000] text-[#181203] text-xs">
              {count}
            </span>
          </motion.button>
        </div>
      </div>
    </header>
  );
};
